import { render, staticRenderFns } from "./AdminUserProfile.vue?vue&type=template&id=473617ea"
import script from "./AdminUserProfile.vue?vue&type=script&lang=js"
export * from "./AdminUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports